import { css } from '@emotion/react';
import { useThemeStore } from '~/components/theme/useThemeStore';
import { createIPadCss } from '~/css/createIPadCss';
import { createMobileCss2 } from '~/css/createMobileCss';
import { meCheckHandlerCreateByProductNameWithExpiredAt } from '~/modules/SDK/me/meCheckHandlerCreateByProductName';
import { store } from '~/pages/heineken_template/_private/store';
import { weng888Stock_initStrategies } from '~/pages/weng888_stock/_private/weng888Stock_initStrategies';
import { weng888Stock_initStyling } from '~/pages/weng888_stock/_private/weng888Stock_initStyling';
import { Weng888Stock_Sidebar1 } from '~/pages/weng888_stock/_private/weng888Stock_Sidebar1';
import { Weng888Stock_Sidebar2 } from '~/pages/weng888_stock/_private/weng888Stock_Sidebar2';
import { Weng888Stock_Topbar } from './weng888Stock_Topbar';
import { useSignalrStart2_0 } from '~/modules/SDK/Signalr/useSignalrStart2_0';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import Fr_WithDrawerCloseButton from '~/pages/heineken_template/_fr/fr_WithDrawerCloseButton';
import { InvestmentLoginView } from '~/modules/investment-consultant/loginPage/InvestmentLoginView';
export const weng888Stock_init = (templateProps) => {
    templateProps.permissions.pageview = meCheckHandlerCreateByProductNameWithExpiredAt('web_stock');
    useThemeStore.setState({ theme: 'dark' });
    weng888Stock_initStyling(templateProps);
    weng888Stock_initStrategies();
    store.charting.widgetOptions = {
        ...store.charting.widgetOptions,
        symbol: 'TSEA',
        interval: '1D',
        enableVolumeIndicator: true,
        disabledHeaderWidget: false,
        disabledLeftToolbar: true,
        disabledHeaderSaveload: true,
        overrides: store.charting.darkOverrides,
    };
    templateProps.layout.cssset = css `
    grid-template-rows: 48px 1fr;
    grid-template-columns: 336px 1fr 336px;

    .MuiModal-backdrop {
      background-color: transparent;
    }

    grid-template-areas:
      'Row1 Row1 Row1'
      'Drawer1 Chart Drawer2'
      'Drawer1 Chart Drawer2';

    ${createIPadCss(css `
      grid-template-rows: 48px 1fr;
      grid-template-columns: 1fr;
      grid-template-areas:
        'Row1 Row1 Row1'
        'Chart Chart Chart';
    `)}

    ${createMobileCss2(css `
      grid-template-rows: 48px 1fr;
      grid-template-columns: 1fr;
      grid-template-areas:
        'Row1 Row1 Row1'
        'Chart Chart Chart';
    `)}
  `;
    templateProps.layout.Drawer1 = (<Fr_WithDrawerCloseButton.Display right Button={<BsChevronLeft css={css `
            #__html {
              position: relative;
              z-index: 100;
            }
            color: #ffffff;
            background-color: #42948844;
            border-radius: 5px;
            height: 64px;
            width: 28px;
            font-size: 24px;
          `}/>}>
      <Weng888Stock_Sidebar1 />
    </Fr_WithDrawerCloseButton.Display>);
    templateProps.layout.Drawer2 = (<Fr_WithDrawerCloseButton.Display left Button={<BsChevronRight css={css `
            #__html {
              position: relative;
              z-index: 100;
            }
            color: #ffffff;
            background-color: #42948844;
            border-radius: 5px;
            height: 64px;
            width: 28px;
            font-size: 24px;
          `}/>}>
      <Weng888Stock_Sidebar2 />
    </Fr_WithDrawerCloseButton.Display>);
    templateProps.layout.login = (<InvestmentLoginView copyright='亞洲證券投顧(109)金管投顧新字第022號 Copyright © 2023' activationCode={false}/>);
    templateProps.layout.Row1 = Weng888Stock_Topbar;
    templateProps.hooks.add(useSignalrStart2_0);
};
